var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"layout__header"},[_c('div',{staticClass:"main-header"},[_c('SearchInput',{on:{"onClick":_vm.onSearchClick},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }